module.exports = __webpack_public_path__ + "static/media/SHBSLong.1a353790.png";